import { render, staticRenderFns } from "./CoinPackagesGrid.vue?vue&type=template&id=e76788e2&"
import script from "./CoinPackagesGrid.vue?vue&type=script&lang=js&"
export * from "./CoinPackagesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports